import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Allroute from './components/Allroute';
import Home from './components/Home';
import Bar from './components/Bar';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Allroute/>
     
    {/* <Bar/> */}

    </div>
  );
}

export default App;
